import { render } from "./CetelemCalculatorBanner.vue?vue&type=template&id=4e85c16d&scoped=true"
import script from "./CetelemCalculatorBanner.vue?vue&type=script&lang=js"
export * from "./CetelemCalculatorBanner.vue?vue&type=script&lang=js"

import "./CetelemCalculatorBanner.vue?vue&type=style&index=0&id=4e85c16d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e85c16d"]])

export default __exports__